export const AUTH_METHOD_NONE = 1
export const AUTH_METHOD_BASIC = 2
export const AUTH_METHOD_TOKEN_BASED = 3
